import { useQuery } from '@apollo/client';
import SaleProductVariantsQuery from './SaleProductVariantsQuery';

const SaleProductVariantsConnectorApollo = ({ children, promoCode, productId }) => {
  const { loading, error, data } = useQuery(SaleProductVariantsQuery, {
    variables: {
      promoCode,
    },
    // fetchPolicy: 'no-cache',
  });

  const result = {
    loading,
    error,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    const productVariant = data.sale.productVariants.find(
      (productVariant) => productVariant.id === productId
    );

    console.log('productId', productId);
    console.log('productVariantFromApollo', productVariant);

    result.productVariant = productVariant;
  }

  return children(result);
};

export default SaleProductVariantsConnectorApollo;
